import React from 'react';

const Tier0Description = () => {
  return (
    <>
      <h5>
        <small>$5per additional 1k MAUs as you grow</small>
      </h5>
      <div>Best for SMB clients starting on their Mobile Growth Journey</div>
    </>
  );
};

export default Tier0Description;
